import { render, staticRenderFns } from "./CommentsDialog.vue?vue&type=template&id=917455f8&scoped=true&"
import script from "./CommentsDialog.vue?vue&type=script&lang=js&"
export * from "./CommentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentsDialog.vue?vue&type=style&index=0&id=917455f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917455f8",
  null
  
)

export default component.exports